<template>
    <div class="col-md-6">
        <div class="card">
            <div class="card-header bg-transparent text-left">
                <strong>Contas a pagar hoje</strong>
            </div>

            <div class="card-body">
                <div class="table-responsive" >
                    <table class="table table-sm table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Descrição</th>
                                <th>Vencimento</th>
                                <th>Valor total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="d in data" :key="d.id" >
                                <td>{{d.NOME}}</td>
                                <td>{{d.VENCIMENTO}}</td>
                                <td>R$ {{d.SALDO}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div> 
</template>
<script>
    export default {
        name: 'gridsBillsToPay',
        data(){
            return{
                data: []
            }
        },
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
        methods: {
            getData: function(){
                fetch('http://45.35.104.234:8084/api/boletos?id=3&page=0', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        this.data = responseJSON.data
                    })
                    .catch(error => {
                        console.log('Error exception', '=>', error)
                    })
            }
        },
        mounted(){
            this.getData()
        }
    }
</script>
<style scoped>

</style>